var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPauseTrack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 100 100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 40.5132,96.886652 c 0,2.000118 -2.174286,3.621818 -4.856363,3.621818 H 8.9469798 c -2.6820768,0 -4.8563622,-1.6217 -4.8563622,-3.621818 V 3.6219083 C 4.0906176,1.6215987 6.264903,0 8.9469798,0 H 35.656837 C 38.338914,0 40.5132,1.6215987 40.5132,3.6219083 Z m 54.633131,0 c 0,2.000118 -2.17442,3.621818 -4.856228,3.621818 H 63.579842 c -2.681807,0 -4.856228,-1.6217 -4.856228,-3.621818 V 3.6219083 C 58.723614,1.6215987 60.898035,0 63.579842,0 h 26.710261 c 2.681808,0 4.856228,1.6215987 4.856228,3.6219083 z",
    id: "path2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPauseTrack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause-track.4637f08d.svg";
export { ForwardRef as ReactComponent };